<template>
  <section class="sponsor">
    <div class="sponsor__headline">
      <AppEyelet
        :data="{
          content: 'Making this event possible.'
        }"
      />
      <AppLine />
      <AppTitle
        class="c-title--dark"
        :data="{
          content: 'Sponsors.'
        }"
      />
      <AppLine />
    </div>
    <ul
      class="sponsor__list"
      data-lazyanimation="stagger"
      v-if="sponsorList"
    >
      <li
        class="sponsor__item"
        v-for="(item, i) in sponsorList"
        :key="`sponsor-${i}`"
        data-item
      >
        <a
          class="sponsor__link"
          :href="item.link"
          aria-label="sponsor icon link"
          target="_blank"
          rel="noopener"
          @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
          @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
        >
          <div
            class="sponsor__icon"
            :style="{
              backgroundImage: `url('${item.iconUrl}')`,
            }"
          />
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import AppLine from '@/components/AppLine.vue';
import AppEyelet from '@/components/AppEyelet.vue';
import AppTitle from '@/components/AppTitle.vue';

export default {
  name: 'AppSponsor',
  components: {
    AppLine,
    AppEyelet,
    AppTitle,
  },

  props: {
    sponsorList: {
      type: [Object, Array],
      required: false,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters(['getSponsor']),
  },
};
</script>

<style lang="scss" scoped>
.sponsor {
  display: grid;
  grid-template-columns: repeat(13, 1fr);

  &__headline {
    grid-column: 1 / -1;

    @include mq(ipadL) {
      grid-column: 1 / 11;
    }
  }
  &__list {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    grid-auto-rows: 100px;

    @include mq(ipadP) {
      grid-template-columns: repeat(3, 1fr);
    }

    @include mq(ipadL) {
      grid-template-columns: repeat(4, 1fr);
      grid-column: 1 / 12;
    }
  }

  &__item {
    a {
      display: block;
      height: 100%;
      align-self: stretch;
      justify-self: stretch;

      padding: 10% 20% 10% 20%;

      @include mq(ipadL) {
        padding: 10% 40% 10% 0;
      }

      @include mq(ipadL) {
        padding: 10% 50% 10% 0;
      }

      @include mq(dl) {
        padding: 6% 30% 6% 0;
      }
    }

    .sponsor__icon {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;

      filter: brightness(0) invert(1);
    }
  }
}
</style>
